/**
 * Split-tap accordion for header drawer.
 *
 * Each .menu-drawer__split-row contains:
 *   - .menu-drawer__split-link  (a real <a> that navigates)
 *   - .menu-drawer__split-toggle (a button that toggles the dropdown)
 *
 * The dropdown is the next sibling element after the split-row.
 * Toggling adds/removes the "is-open" class on the wrapping <li> (or its parent),
 * which CSS uses to show the submenu and rotate the chevron.
 */
(function () {
  function init() {
    var toggles = document.querySelectorAll('.menu-drawer__split-toggle');

    toggles.forEach(function (toggle) {
      // Avoid double-binding if this script runs more than once
      if (toggle.dataset.bound === 'true') return;
      toggle.dataset.bound = 'true';

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        // The wrapping container we toggle "is-open" on
        var wrapper = toggle.closest('.menu-drawer__split-accordion');
        if (!wrapper) return;

        var isOpen = wrapper.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      // Initialize aria-expanded
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind when the drawer is re-rendered via Shopify's Section Rendering API
  document.addEventListener('shopify:section:load', init);
})();
